import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import ProtectedRoute from './components/ProtectedRoute';
import LoginPage from './pages/LoginPage';
import DashboardPage from './pages/DashboardPage';
import UsersPage from './pages/UsersPage';
import OrdersPage from './pages/OrdersPage';
import OrderDetailPage from './pages/OrderDetailPage';
import ApprovalPage from './pages/ApprovalPage';
import ShopeeValidationsPage from './pages/ShopeeValidationsPage';
import WithdrawalsPage from './pages/WithdrawalsPage';
import ClicksPage from './pages/ClicksPage';
import ShareCommissionsPage from './pages/ShareCommissionsPage';
import LostOrdersPage from './pages/LostOrdersPage';
import ShopeeFoodPage from './pages/ShopeeFoodPage';
import SettingsPage from './pages/SettingsPage';
import Layout from './components/Layout';

function App() {
  return (
    <AuthProvider>
      <div className="min-h-screen bg-gray-50">
        <Routes>
          <Route path="/login" element={<LoginPage />} />
          <Route path="/" element={
            <ProtectedRoute>
              <Layout />
            </ProtectedRoute>
          }>
            <Route index element={<Navigate to="/dashboard" replace />} />
            <Route path="dashboard" element={<DashboardPage />} />
            <Route path="users" element={<UsersPage />} />
            <Route path="clicks" element={<ClicksPage />} />
            <Route path="share-commissions" element={<ShareCommissionsPage />} />
            {/* Đường dẫn cũ của 3 trang click riêng */}
            <Route path="user-orders" element={<Navigate to="/clicks?platform=shopee" replace />} />
            <Route path="lazada-user-orders" element={<Navigate to="/clicks?platform=lazada" replace />} />
            <Route path="tiktok-clicks" element={<Navigate to="/clicks?platform=tiktokshop" replace />} />
            <Route path="lost-orders" element={<LostOrdersPage />} />
            <Route path="shopeefood" element={<ShopeeFoodPage />} />
            <Route path="orders" element={<OrdersPage />} />
            <Route path="orders/:id" element={<OrderDetailPage />} />
            <Route path="approval" element={<ApprovalPage />} />
            <Route path="shopee-validations" element={<ShopeeValidationsPage />} />
            <Route path="shopee-validations/:runId" element={<ShopeeValidationsPage />} />
            <Route path="withdrawals" element={<WithdrawalsPage />} />
            <Route path="settings" element={<SettingsPage />} />
          </Route>
        </Routes>
      </div>
    </AuthProvider>
  );
}

export default App;
